import { render, staticRenderFns } from "./Kaiye.vue?vue&type=template&id=9dfcd87a&scoped=true"
import script from "./Kaiye.vue?vue&type=script&lang=js"
export * from "./Kaiye.vue?vue&type=script&lang=js"
import style0 from "./Kaiye.vue?vue&type=style&index=0&id=9dfcd87a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dfcd87a",
  null
  
)

export default component.exports